import React from 'react';

export type IconButtonTone = 'neutral' | 'brand' | 'danger';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string; // acción accesible: se usa como aria-label y title (única fuente, no se duplica en texto visible)
  tone?: IconButtonTone;
  icon: React.ReactNode;
}

const TONE_CLASSES: Record<IconButtonTone, string> = {
  neutral: 'text-slate-500 hover:text-slate-700 hover:bg-slate-100',
  brand: 'text-brand-700 hover:text-brand-800 hover:bg-brand-50',
  danger: 'text-red-500 hover:text-red-700 hover:bg-red-50',
};

export const IconButton: React.FC<IconButtonProps> = ({
  label,
  tone = 'neutral',
  icon,
  className = '',
  ...rest
}) => {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={`inline-flex items-center justify-center h-8 w-8 rounded-md transition-colors
        focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500
        disabled:opacity-40 disabled:cursor-not-allowed ${TONE_CLASSES[tone]} ${className}`}
      {...rest}
    >
      {icon}
    </button>
  );
};

export default IconButton;
